import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/utils/gtm";
import { getAttribution } from "@/utils/attribution";
import { diagnosticEventLog } from "@/shared/services/diagnostic";

/**
 * Pushes a `page_view` event to the dataLayer on every route change.
 * The first page view includes attribution data (UTM source, referrer)
 * so GA4 can attribute the session to its traffic source.
 * Must be rendered inside a `<Router>`.
 */
export function usePageTracking() {
  const { pathname, search } = useLocation();
  const isFirstView = useRef(true);

  useEffect(() => {
    // Attach attribution to the first page_view only
    const attr = isFirstView.current ? getAttribution() : null;
    if (isFirstView.current) isFirstView.current = false;

    diagnosticEventLog.record("navigation:app", "info", "route-change", {
      path: pathname + search,
    });

    trackPageView({
      page_path: pathname + search,
      page_title: document.title,
      ...(attr && {
        utm_source: attr.utm_source,
        utm_medium: attr.utm_medium,
        utm_campaign: attr.utm_campaign,
        referrer_domain: attr.referrer_domain,
        landing_page: attr.landing_page,
      }),
    });
  }, [pathname, search]);
}
